import { render } from "./App.vue?vue&type=template&id=013f5ffa"
const script = {}

import exportComponent from "C:\\Workspaces\\proxis\\ip-phone-camera.deskshare\\IPPhoneCameraWebView\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__